// Small pieces the product screens share: their own marks (plus, the up and down arrows, the tick),
// a product's cover as the Products board draws it, the board's larger Live switch, and a section's
// heading row with its line on the right.
import { useState } from 'react'
import { coverStyle } from './model.js'

const PATHS = {
  plus: <path d="M12 5v14M5 12h14" />,
  up: <path d="m18 15-6-6-6 6" />,
  down: <path d="m6 9 6 6 6-6" />,
  tick: <path d="M20 6 9 17l-5-5" />,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>,
}

export function Mark({ name, size = 14, className = 'ap-mark' }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {PATHS[name] || null}
    </svg>
  )
}

// The cover box on a product's card: its photo when there's 1 and it loads, else its look with the
// name on it (AdminProducts.dc.html)
export function Cover({ product, url, size = 'paid' }) {
  const [broken, setBroken] = useState(false)
  const c = coverStyle(product)
  if (url && !broken) {
    return (
      <span className={`ap-cover ap-cover--${size} ap-cover--photo`} aria-hidden="true">
        <img src={url} alt="" onError={() => setBroken(true)} />
      </span>
    )
  }
  const style = c.own ? { background: c.own.bg, color: c.own.text, fontFamily: c.own.font, fontWeight: c.own.weight } : undefined
  return <span className={`ap-cover ap-cover--${size} ap-cover--${c.cls}`} style={style} aria-hidden="true">{c.text}</span>
}

// The Products board's switch (46 by 26), beside each product
export function BigSwitch({ checked, label, onClick, disabled }) {
  return (
    <button type="button" role="switch" className="ad-switch ap-switch" aria-checked={Boolean(checked)} aria-label={label}
      disabled={disabled} onClick={onClick}>
      <span className="ad-switch-knob" />
    </button>
  )
}

// "Paid" with its line on the right
export function SectionHead({ id, title, aside }) {
  return (
    <div className="ap-sechead">
      <h2 className="ap-sechead-h" id={id}>{title}</h2>
      {aside && <span className="ap-sechead-aside">{aside}</span>}
    </div>
  )
}

// A chip on a product's title line: its type, Free, Live or Draft
export function Chip({ kind = 'type', children }) {
  return <span className={`ap-chip ap-chip--${kind}`}>{children}</span>
}
